import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LoginService } from "./login/login.service";
import { LocalStorageService } from "./shared/local-storage.service";
import { environment } from "../environments/environment";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false,
})
export class AppComponent implements OnInit {
    title = "htl-part";
    showTestBanner = false;

    constructor(
        public translate: TranslateService,
        private _localStorageService: LocalStorageService,
        private _loginService: LoginService,
    ) {
        if (!environment.production) {
            this.showTestBanner = true;
        }
        translate.addLangs(["en", "de", "it"]);
        const browserLang = translate.getBrowserLang();
        if (this._localStorageService.appLocalStorageExist()) {
            const sessionObject = this._localStorageService.getAppLocalStorageObject();
            translate.use(sessionObject.lang);
            translate.setFallbackLang("en");
        } else {
            const lang = browserLang.match(/en|de|it/) ? browserLang : "en";
            translate.use(lang);
            this._localStorageService.setAppLocalStorage("lang", lang);
            translate.setFallbackLang("en");
        }
    }

    ngOnInit(): void {
        this._loginService.autoLogin();
    }
}
